module.exports = __webpack_public_path__ + "img/func_3_3.cbd0b584.svg";